export const removeChildren = (element) => {
  while (element.firstChild) element.removeChild(element.firstChild)
}


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/utilities/remove-children.js